module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-07.631cd566.svg";